export * from "expo-router/build/react-navigation/material-top-tabs/index";
export type { MaterialTopTabNavigationConfig } from "expo-router/build/react-navigation/material-top-tabs/types";
export {
  appendMissingPlaceholderTabDescriptors,
  appendMissingPlaceholderTabRoutes,
} from "expo-router/build/standard-navigation/appendMissingPlaceholderTabRoutes";
